/**
 * The orderItems provided by the API
 */
import {Model} from './Model';

export class OrderItem extends Model {
  public productId: number = 0;
  public quantity: number = 0;
  public slotId: number | null = null;
  public personalUse: boolean = false;
  public parentId: string | number | null = null;
  public subOrderItems: Array<OrderItem> = [];
  public registrationRequired: string = '';

  constructor(data: any) {
    super(data);
    this.productId = data.productId;
    this.quantity = data.quantity;
    this.personalUse = data.personalUse;
    this.parentId = data.parentId;
    data.subOrderItems.forEach((subOrderItem) => {
      this.subOrderItems.push(new OrderItem(subOrderItem));
    });
    if (data.slotId) {
      this.slotId = data.slotId;
    }
    this.registrationRequired = data.registrationRequired;
  }

  get isProductFamily() {
    return this.subOrderItems.length > 0;
  }

  get isSubProduct() {
    return this.parentId !== null;
  }

  get isRegistrationRequired() {
    // registrationRequired can be 'Ja', 'Nein' or 'Optional'
    return this.registrationRequired === 'Ja' || this.registrationRequired === '';
  }

  get isRegistrationOptional() {
    // registrationRequired can be 'Ja', 'Nein' or 'Optional'
    return this.registrationRequired === 'Optional';
  }

  toString(): string {
    return `OrderItem<${this.productId}, ${this.quantity}, ${this.slotId}>`;
  }
}
